import { Link } from 'react-router-dom';
import { analyses } from '@/mocks/analyses';
import { categories } from '@/mocks/categories';

export default function FeaturedAnalyses() {
  const list = analyses.slice(0, 4);
  const categoryName = (id: string) =>
    categories.find((cat) => cat.id === id)?.shortName ?? '综合';

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-5 py-4 border-b border-background-200">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 flex items-center gap-2">
          <i className="ri-line-chart-line text-accent-600 w-5 h-5 flex items-center justify-center" />
          精选数据分析
        </h3>
        <span className="text-xs text-foreground-500">黑5专题</span>
      </div>

      <ul className="divide-y divide-background-200">
        {list.map((item) => (
          <li key={item.id}>
            <Link
              to={`/analysis/${item.id}`}
              className="group flex gap-3 p-4 hover:bg-background-100/70 transition-colors"
            >
              <span className="w-20 h-16 md:w-24 md:h-[68px] rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} 数据分析`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] bg-accent-100 text-accent-800">
                    {categoryName(item.categoryId)}
                  </span>
                  <span className="text-[11px] text-foreground-500">{item.readTime}</span>
                </div>
                <h4 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
                  {item.title}
                </h4>
                <p className="mt-1 text-xs text-foreground-600 line-clamp-1">{item.subtitle}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}